export const REASON_CONFIG = {
  RAPPEL: { label: "Rappel", color: "reason-callback", icon: "bi-telephone-inbound" },
  CALLBACK: {
    label: "Rappel",
    color: "reason-callback",
    icon: "bi-telephone-inbound",
  },
  OCCUPE: { label: "Occupé", color: "reason-occupe", icon: "bi-telephone-x" },
  REPONDEUR: {
    label: "Répondeur",
    color: "reason-repondeur",
    icon: "bi-speakerphone",
  },
  NI: {
    label: "Pas intéressé",
    color: "reason-ni",
    icon: "bi-hand-thumbs-down",
  },
  SVI: { label: "Serveur vocal", color: "reason-neutral", icon: "bi-telephone" },
  NO_ANSWER: { label: "Sans réponse", color: "reason-neutral", icon: "bi-telephone-x" },
  NON_REPONSE: { label: "Sans réponse", color: "reason-neutral", icon: "bi-telephone-x" },
};

export const STATUS_CONFIG = {
  pending: {
    label: "En attente",
    color: "status-pending",
    icon: "bi-hourglass-split",
  },
  running: {
    label: "En cours",
    color: "status-running",
    icon: "bi-arrow-repeat",
  },
  done: { label: "Traité", color: "status-done", icon: "bi-check-circle" },
  failed: { label: "Échec d’exécution", color: "status-failed", icon: "bi-x-circle" },
  cancelled: { label: "Annulé", color: "status-neutral", icon: "bi-slash-circle" },
  indeterminate: { label: "Exécution à vérifier", color: "status-review", icon: "bi-exclamation-triangle" },
};

export const RESULT_CONFIG = {
  CALLBACK: { label: "Rappel", color: "reason-callback" },
  OCCUPE: { label: "Occupé", color: "reason-occupe" },
  REPONDEUR: { label: "Répondeur", color: "reason-repondeur" },
  NI: { label: "Pas intéressé", color: "reason-ni" },
  SALE: { label: "Vente / RDV", color: "reason-sale" },
  SVI: { label: "Serveur vocal", color: "reason-neutral" },
  NO_ANSWER: { label: "Sans réponse", color: "reason-neutral" },
  NON_REPONSE: { label: "Sans réponse", color: "reason-neutral" },
  NPA: { label: "Ne plus appeler", color: "reason-ni" },
  HORS_CIBLE: { label: "Hors cible", color: "reason-neutral" },
  TECHNICAL_ERROR: { label: "Erreur technique", color: "status-failed" },
  SKIPPED: { label: "Non exécuté", color: "reason-neutral" },
};
